import * as React from "react";
import { OptionForm } from "../../../components/OptionForm";
import AppBody from "../../../components/AppBody";
import Header from "../../../components/Header";
import IssuerHeader from "../../../components/IssuerHeader";
import RouteHeaderLogo from "../../../components/RouteHeaderLogo";
export var RememberLoginOptions;
(function (RememberLoginOptions) {
    RememberLoginOptions["YES"] = "Yes";
    RememberLoginOptions["NO_FORGOT_LOGIN"] = "No - Forgot my login";
})(RememberLoginOptions || (RememberLoginOptions = {}));
export default function BaseRememberLoginRoute(_a) {
    var issuer = _a.issuer, options = _a.options;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(IssuerHeader, { issuer: issuer }),
            React.createElement(OptionForm, { submitId: "knows-login", prompt: "Do you know your login at this time?", options: options }))));
}
